import styled from 'styled-components';

import { SEMANTIC_COLORS } from '../../../constant/unit/color';

export const S = {
  Layout: styled.div<{ minHeight: number; customLayout?: string }>`
    display: flex;
    flex-direction: column;

    width: 100%;
    min-height: ${(props) => `${props.minHeight}px`};
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};

    ${(props) => props.customLayout};
  `,
};
